const EmptyContent = ({ text = '존재하지 않습니다.' }: { text: string }) => {
  return (
    <div className="micEmptyWrap">
      <div className="micEmptyArea">
        <div className="micEmptyCon">{text}</div>
      </div>
    </div>
  );
};

export default EmptyContent;
